var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-table"},[_c('v-server-table',{ref:_vm.tableRef,attrs:{"url":_vm.url,"name":_vm.name,"columns":_vm.tableColumns,"options":_vm.tableOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }